import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import server from 'server/serverController2'
import styled from 'styled-components'
import { useCookies } from 'react-cookie'

import SocialLoginContainer from 'components/containers/login/SocialLoginContainer'

import CenterModal from 'components/presenters/modal/CenterModal'
import TermsAndConditionCheckModal from 'components/containers/signup/TermsAndConditionCheckModal'
import TitleHeader from 'components/presenters/header/TitleHeader'
import EmailFormScene from 'components/containers/signup/EmailFormScene'
import PhoneSMSAuthScene from 'components/containers/signup/PhoneSMSAuthScene'
import GenderAndBirthScene from 'components/containers/signup/GenderAndBirthScene'
import UserCategoryScene from 'components/containers/signup/UserCategoryScene'
import UserDetailCategoryScene from 'components/containers/signup/UserDetailCategoryScene'
import NicknameFormScene from 'components/containers/signup/NicknameFormScene'
import ConfirmNotificationScene from 'components/containers/signup/ConfirmNotificationScene'
import { getQueryStringObject } from 'utils/utils'
import { UserInfoActions, UserPermissionActions } from 'store/actionCreators'
import { sendWebViewMsg } from 'utils/bridge'
import useCreateOnboardingTodoMutate from 'hooks/queries/task/useCreateOnboardingTodoMutate'

export default function SocialLoginLayout() {
  const [cookies, setCookie, removeCookie] = useCookies()
  const history = useHistory()
  const queryString = getQueryStringObject()
  const redirectPath = queryString['redirect_path']

  const isOnboarding = useLocation().state?.isOnboarding ?? false

  const [signupScene, setSignupScene] = useState([])
  const [currScene, setCurrScene] = useState(0)
  const [isLoginScene, setIsLoginScene] = useState(true)
  const [socialData, setSocialData] = useState({})

  //state for after signup
  const [userInfoSetted, setUserInfoSetted] = useState(false)

  //Fields Data for Signup
  const [authToken, setAuthToken] = useState(null)
  const [socialType, setSocialType] = useState(null)
  const [email, setEmail] = useState(null)
  const [phone, setPhone] = useState(null)
  const [phoneToken, setPhoneToken] = useState(null)
  const [sex, setSex] = useState(null)
  const [birth, setBirth] = useState(null)
  const [parentCategories, setParentCategories] = useState([])
  const [detailCategories, setDetailCategories] = useState([])
  const [nickname, setNickname] = useState(null)

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  const { mutateAsync: createOnboardingTodo } = useCreateOnboardingTodoMutate()

  //TermsAndConditionModal
  const [termsAndConditionCheckModalVisible, setTermsAndConditionCheckModalVisible] =
    useState(false)

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  useEffect(() => {
    //login
    if (userInfoSetted === true) {
      if (redirectPath && redirectPath.length > 0) {
        history.replace(redirectPath)
      } else {
        history.replace('/')
      }
    }
  }, [history, redirectPath, userInfoSetted])

  useEffect(() => {
    const newSignupScene = []
    let totalScene = 3
    if (!socialData['email']) {
      ++totalScene
    }
    if (!socialData['phone']) {
      ++totalScene
    }
    if (!socialData['sex'] || !socialData['birth']) {
      ++totalScene
    }

    if (!socialData['email']) {
      newSignupScene.push(
        <EmailFormScene
          initEmail={email}
          currSceneNum={currScene + 1}
          totalSceneNum={totalScene}
          onComplete={(email) => {
            setEmail(email)
            setCurrScene(currScene + 1)
          }}
          onError={(error) => {}}
        />,
      )
    }

    if (!socialData['phone']) {
      newSignupScene.push(
        <PhoneSMSAuthScene
          initPhone={phone}
          currSceneNum={currScene + 1}
          totalSceneNum={totalScene}
          onComplete={(data) => {
            setCurrScene(currScene + 1)
            setPhone(data['phone'])
            setPhoneToken(data['token'])
          }}
          onError={(error) => {
            if (error['detail_code'] === 'SMS_DATA_NOT_EXIST') {
              setCenterModalVisible(true)
              setCenterModalDataList({ description: '인증번호가 맞지 않아요.' })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            } else if (error['detail_code'] === 'TIME_EXCEEDED') {
              setCenterModalVisible(true)
              setCenterModalDataList({ description: '시간이 초과되었어요.\n 다시 시도해 주세요.' })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            }
          }}
        />,
      )
    }

    if (!socialData['sex'] || !socialData['birth']) {
      newSignupScene.push(
        <GenderAndBirthScene
          initSex={sex}
          initBirth={birth}
          currSceneNum={currScene + 1}
          totalSceneNum={totalScene}
          onComplete={(data) => {
            setCurrScene(currScene + 1)
            setSex(data.sex)
            setBirth(data.birth)
          }}
          onError={(error) => {}}
        />,
      )
    }

    newSignupScene.push(
      <UserCategoryScene
        initCategories={parentCategories}
        currSceneNum={currScene + 1}
        totalSceneNum={totalScene}
        onComplete={(data) => {
          setParentCategories(data['categories'])
          setCurrScene(currScene + 1)
        }}
        onError={(error) => {}}
      />,
    )
    newSignupScene.push(
      <UserDetailCategoryScene
        initCategories={detailCategories}
        parentCategories={parentCategories}
        currSceneNum={currScene + 1}
        totalSceneNum={totalScene}
        onComplete={(data) => {
          setDetailCategories(data['categories'])
          setCurrScene(currScene + 1)
        }}
        onError={(error) => {}}
      />,
    )

    newSignupScene.push(
      <NicknameFormScene
        currSceneNum={currScene + 1}
        totalSceneNum={totalScene}
        onComplete={(nickname) => {
          setNickname(nickname)
          setTermsAndConditionCheckModalVisible(true)
        }}
        onError={(error) => {}}
      />,
    )

    newSignupScene.push(
      <ConfirmNotificationScene currSceneNum={currScene + 1} totalSceneNum={totalScene} />,
    )

    setSignupScene(newSignupScene)
  }, [
    email,
    phone,
    sex,
    birth,
    parentCategories,
    detailCategories,
    nickname,
    socialData,
    currScene,
  ])

  const printCurrSignupScene = () => {
    return signupScene[currScene]
  }

  const signupUser = async (checkedList) => {
    const body = {}
    body['email'] = email
    body['phone'] = phone
    body['phone_token'] = phoneToken
    body['sex'] = sex
    body['birth'] = birth
    body['category_no_list'] = [...parentCategories, ...detailCategories].map((data) => data.no)
    body['nickname'] = nickname
    body['auth_token'] = authToken
    if (!checkedList.includes(3)) {
      body['push_notification'] = false
    } else {
      body['push_notification'] = true
    }

    console.log('user data')
    console.log(body)
    console.log('socialType')
    console.log(socialType)
    if (socialType === 'kakao') {
      server.postRequestData(`auth/kakao/signup`, body, async (res) => {
        try {
          if (res.success !== 1) {
            let errData = res.error.res_data
            console.log(errData)
            //INVALID_AUTH_TOKEN
            if (errData['detail_code'] === 'INVALID_AUTH_TOKEN') {
              setCenterModalVisible(true)
              setCenterModalDataList({
                description: '카카오 인증에 실패했습니다.\n 다시 시도해주세요.',
              })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            } else {
              setCenterModalVisible(true)
              setCenterModalDataList({
                description: '회원가입에 실패했습니다.\n 다시 시도해주세요.',
              })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            }

            return
          }
          const userData = res.data.user
          UserInfoActions.updateUserState({
            name: userData.nickname,
            email: userData.email,
            id: userData.no,
            isLogin: true,
            achievement_goal: userData.achievement_goal,
            profile_img: userData.profile_img,
            exp_point: userData.exp_point,
          })

          UserInfoActions.updateRole({
            role: userData.role,
          })
          if (res?.data?.permissions) {
            UserPermissionActions.updateUserPermission({
              matching: res?.data?.permissions['matching'],
            })
          }

          if (cookies['onboarding_habit']
            && cookies['onboarding_description'] !== undefined
            && cookies['onboarding_original_image_name']
            && cookies['onboarding_original_image_path']
            && cookies['onboarding_merged_image_name']
            && cookies['onboarding_merged_image_path']
          ) {
            try {
              await createOnboardingTodo({
                onboardingType: cookies['onboarding_habit'],
                description: cookies['onboarding_description'],
                originalImageName: cookies['onboarding_original_image_name'],
                originalImagePath: cookies['onboarding_original_image_path'],
                mergedImageName: cookies['onboarding_merged_image_name'],
                mergedImagePath: cookies['onboarding_merged_image_path'],
              })
    
              removeCookie('onboarding_habit', { path: '/' })
              removeCookie('onboarding_description', { path: '/' })
              removeCookie('onboarding_original_image_name', { path: '/' })
              removeCookie('onboarding_original_image_path', { path: '/' })
              removeCookie('onboarding_merged_image_name', { path: '/' })
              removeCookie('onboarding_merged_image_path', { path: '/' })
              
            } catch (e) {
              setCenterModalVisible(true)
              setCenterModalDataList({
                description: '3일 챌린지 인증기록을 저장하지 못했어요.\n카카오로 문의 주시면 해결해 드릴게요.',
                confirmTxt: '문의하기',
              })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
                window.open('https://pf.kakao.com/_gmtJs/chat', '_blank')
              })
              setOnModalCancel(()=> () => {
                setInitCenterModal(true)
              })
              return
            }
          }

          setCookie('is_onboarding_completed', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
          sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })

          if (!checkedList.includes(3)) {
            setCurrScene(currScene + 1)
            setTermsAndConditionCheckModalVisible(false)
            return
          }
          setUserInfoSetted(true)
        } catch (err) {
          console.log(err)
        }
      })
    }
    if (socialType === 'apple') {
      server.postRequestData('auth/apple/signup', body, async (res) => {
        try {
          if (res.success !== 1) {
            const errData = res.error.res_data
            if (errData['detail_code'] === 'INVALID_AUTH_TOKEN') {
              setCenterModalVisible(true)
              setCenterModalDataList({
                description: '애플 인증에 실패했습니다.\n 다시 시도해주세요.',
              })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            } else {
              setCenterModalVisible(true)
              setCenterModalDataList({
                description: '회원가입에 실패했습니다.\n 다시 시도해주세요.',
              })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            }
            return
          }
          const userData = res.data.user
          UserInfoActions.updateUserState({
            name: userData.nickname,
            email: userData.email,
            id: userData.no,
            isLogin: true,
            achievement_goal: userData.achievement_goal,
            profile_img: userData.profile_img,
            exp_point: userData.exp_point,
          })
          UserInfoActions.updateRole({
            role: userData.role,
          })
          if (res?.data?.permissions) {
            UserPermissionActions.updateUserPermission({
              matching: res?.data?.permissions['matching'],
            })
          }

          if (cookies['onboarding_habit']
            && cookies['onboarding_description'] !== undefined
            && cookies['onboarding_original_image_name']
            && cookies['onboarding_original_image_path']
            && cookies['onboarding_merged_image_name']
            && cookies['onboarding_merged_image_path']
          ) {
            try {
              await createOnboardingTodo({
                onboardingType: cookies['onboarding_habit'],
                description: cookies['onboarding_description'],
                originalImageName: cookies['onboarding_original_image_name'],
                originalImagePath: cookies['onboarding_original_image_path'],
                mergedImageName: cookies['onboarding_merged_image_name'],
                mergedImagePath: cookies['onboarding_merged_image_path'],
              })
    
              removeCookie('onboarding_habit', { path: '/' })
              removeCookie('onboarding_description', { path: '/' })
              removeCookie('onboarding_original_image_name', { path: '/' })
              removeCookie('onboarding_original_image_path', { path: '/' })
              removeCookie('onboarding_merged_image_name', { path: '/' })
              removeCookie('onboarding_merged_image_path', { path: '/' })
              
            } catch (e) {
              setCenterModalVisible(true)
              setCenterModalDataList({
                description: '3일 챌린지 인증기록을 저장하지 못했어요.\n카카오로 문의 주시면 해결해 드릴게요.',
                confirmTxt: '문의하기',
              })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
                window.open('https://pf.kakao.com/_gmtJs/chat', '_blank')
              })
              setOnModalCancel(()=> () => {
                setInitCenterModal(true)
              })
              return
            }
          }

          setCookie('is_onboarding_completed', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
          sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })

          if (!checkedList.includes(3)) {
            setCurrScene(currScene + 1)
            setTermsAndConditionCheckModalVisible(false)
            return
          }
          setUserInfoSetted(true)
        } catch (err) {
          console.log(err)
        }
      })
    }
  }

  return (
    <>
      {isLoginScene ? (
        <SocialLoginSection>
          <SocialLoginContainer
            onSignupReq={(data) => {
              setIsLoginScene(false)
              // const receivedData = data
              setAuthToken(data['auth_token'])
              setSocialType(data['type'])

              if (data['email']) {
                setEmail(data['email'])
              }

              if (data['phone']) {
                setPhone(data['phone'])
              }
              if (data['sex']) {
                setSex(data['sex'])
              }
              if (data['birth']) {
                setBirth(data['birth'])
              }

              if (data['nickname']) {
                setNickname(data['nickname'])
              }

              setSocialData(data)
              //category, categoryDetail
            }}
            isOnboarding={isOnboarding}
          />
        </SocialLoginSection>
      ) : (
        <SignupWrapper>
          {currScene !== signupScene.length - 1
            ? <HeaderWrapper>
                <TitleHeader
                  hideBtn={currScene === signupScene.length - 1}
                  title={currScene !== signupScene.length - 1 ? '회원가입' : ''}
                  onBackBtn={() => {
                    if (currScene <= 0) {
                      setIsLoginScene(true)
                    } else {
                      setCurrScene(currScene - 1)
                    }
                  }}
                />
              </HeaderWrapper>
            : null
          }
          <BodyWrapper>{printCurrSignupScene()}</BodyWrapper>
          {termsAndConditionCheckModalVisible ? (
            <TermsAndConditionCheckModal
              setTermsAndConditionCheckModalVisible={setTermsAndConditionCheckModalVisible}
              onComplete={signupUser}
            />
          ) : null}
        </SignupWrapper>
      )}
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
    </>
  )
}

const SocialLoginSection = styled.div`
  width: 100%;
  height: 100vh;
  background: #fffaeb;
`

const SignupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`

const HeaderWrapper = styled.div`
  flex-shrink: 0;
  height: calc(100vw * (51 / 375));
  max-height: calc(100vw * (51 / 375));
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  height: calc(100vh - calc(100vw * (51 / 375)));
`
